import React from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import * as actions from 'containers/Settings/Leads/actions';
import { Loading } from 'components/Loading';
import Card from 'components/Cards/OrgMemberCard';

const IncomingNotifications = () => {
  const notificationUsers = useSelector(state => state.settings.leadSettings.notificationUsers);
  const items = notificationUsers.map(item => ({ ...item, checked: item.isLeadContact }));
  const assignedUsers = notificationUsers.filter(item => item.isLeadContact);
  const loaded = useSelector(state => state.settings.leadSettings.isNotificationUserLoaded);

  const dispatch = useDispatch();
  const { addLeadContact, deleteLeadContact } = bindActionCreators(actions, dispatch);

  const addOrgLeadContact = ({ loginId }) => {
    addLeadContact({ loginId });
  };

  const deleteOrgLeadContact = ({ loginId, orgId, orgLeadContact }) => {
    if (orgLeadContact && loginId && orgId) deleteLeadContact({ loginId, orgLeadContactId: orgLeadContact.id });
  };

  return (
    <>
      <p className="lead-setting__intro">
        Select the team members who will get notified when a new lead drops
        into your lead manager from your contact forms or your listing.{' '}
        <a
          href="https://help.aisleplanner.com/en/articles/2324392-setting-incoming-lead-notifications"
          target="_blank"
          rel="noreferrer"
        >
          Learn more here
        </a>
        .
      </p>
      <div className={clsx('lead-setting__status-list', 'row', !loaded && 'loading')}>
        {!loaded ? (
          <Loading />
        ) : items.map((item, index) => (
          <Card
            key={`modal-card__${index}`}
            {...item}
            setMember={addOrgLeadContact}
            unsetMember={deleteOrgLeadContact}
          />
        ))}
      </div>
      {!assignedUsers.length && (
        <p className="lead-setting__warning">
          We noticed you've removed all lead notifications.
          We recommend notifying at least one team member to help you stay on top of new leads.
        </p>
      )}
    </>
  );
};

export default IncomingNotifications;
